export const getDisabledFields = entityType => {
  if (!entityType || entityType === '') {
    return {
      paoCode: true,
      ddoCode: true,
      ddoRegistrationNumber: true,
      paoRegistrationNumber: true,
      ministryName: true,
      ministryNameOther: true,
      stateMinistry: true,
      paoRegistrationNo:true,
      ddoRegistrationNo:true,
      stateName: true,
    }
  }

  const disabledFieldsForNonGovTypes = [
    'paoCode',
    'ddoCode',
    'ddoRegistrationNumber',
    'paoRegistrationNumber',
    'paoRegistrationNo',
    'ministryName',
    'ministryNameOther',
    'stateMinistry',
    'ddoRegistrationNo',
    'stateName',
  ]

  const nonGovEntityTypes = [
    'COMPANY',
    'BRANCH/DIVISION OF COMPANY',
    'ASSOCIATION OF PERSON (AOP)',
    'ASSOCIATION OF PERSON (TRUST)',
    'ARTIFICIAL JURIDICAL PERSON',
    'BODY OF INDIVIDUALS',
    'INDIVIDUAL/HUF',
    'FIRM',
  ]

  const govTypesRequiringState = [
    'STATE GOVERNMENT',
    'STATUTORY BODY (STATE GOVT.)',
    'AUTONOMOUS BODY (STATE GOVT.)',
    'LOCAL AUTHORITY (STATE GOVT.)',
  ]

  const govTypesRequiringMinistry = [
    'CENTRAL GOVERNMENT',
    'STATUTORY BODY (CENTRAL GOVT.)',
    'STATUTORY BODY (STATE GOVT.)',
    'AUTONOMOUS BODY (CENTRAL GOVT.)',
    'AUTONOMOUS BODY (STATE GOVT.)',
    'LOCAL AUTHORITY (CENTRAL GOVT.)',
    'LOCAL AUTHORITY (STATE GOVT.)',
  ]

  const govTypesRequiringPAODDO = [
    'STATE GOVERNMENT',
    'STATUTORY BODY (CENTRAL GOVT.)',
    'STATUTORY BODY (STATE GOVT.)',
    'AUTONOMOUS BODY (CENTRAL GOVT.)',
    'AUTONOMOUS BODY (STATE GOVT.)',
    'LOCAL AUTHORITY (CENTRAL GOVT.)',
    'LOCAL AUTHORITY (STATE GOVT.)',
  ]

  const disabledFields = {}

  // Disable government specific fields for non-government entity types
  if (nonGovEntityTypes.includes(entityType)) {
    disabledFieldsForNonGovTypes.forEach(field => {
      disabledFields[field] = true
    })
  } else {
    // Enable fields based on entity type
    disabledFields.paoCode =
      entityType !== 'CENTRAL GOVERNMENT' &&
      !govTypesRequiringPAODDO.includes(entityType)
    disabledFields.ddoCode =
      entityType !== 'CENTRAL GOVERNMENT' &&
      !govTypesRequiringPAODDO.includes(entityType)
    disabledFields.ddoRegistrationNumber =
      nonGovEntityTypes.includes(entityType)
    disabledFields.ddoRegistrationNo = nonGovEntityTypes.includes(entityType)
    disabledFields.paoRegistrationNumber =
      nonGovEntityTypes.includes(entityType)
    disabledFields.paoRegistrationNo = nonGovEntityTypes.includes(entityType)
    disabledFields.ministryName =
      !govTypesRequiringMinistry.includes(entityType)
    disabledFields.ministryNameOther =
      !govTypesRequiringMinistry.includes(entityType)
    disabledFields.stateMinistry = !govTypesRequiringState.includes(entityType)
    disabledFields.stateName = !govTypesRequiringState.includes(entityType)
  }

  return disabledFields
}
